module.exports = __webpack_public_path__ + "img/banner.e3c5e4a3.png";